<template>
  <div class="wrapper">
    <div class="search">
      <div class="search-ipt">
        <div class="search-input">
          <input type="text" placeholder="搜索客户名称" v-model="searchParams.name">
        </div>
        <div class="search-icon" @click="onRefresh">
          搜索
        </div>
      </div>
      <div class="filter-option">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="searchParams.invoiceType"
            :options="invoiceTypeOptions"
            @change="changeType"
          />
          <van-dropdown-item
            v-model="searchOptions.drewDate"
            :options="drewDateOptions"
            @change="changeDrewDate"
          />
        </van-dropdown-menu>
        <p class="filter-btn" @click="openAllCard" v-if="!cardOpened">关联快递单</p>
      </div>
    </div>
    <div class="pull-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-swipe-cell
            v-for="(invoice, index) in invoiceList"
            :key="index" :ref="'swipecell'+invoice.id"
            :name="invoice.id"
            :disabled="true"
            :before-close="beforeClose"
            :class="[!cardOpened ? 'swiper-cell-custom-wrp': ''].join(' ')"
          >
            <template #left>
              <div class="select-wrp" v-if="!invoice.select"><i class="iconfont select-font" v-tap="{methods: selectInvoice, params:{invoice}}">&#xe69c;</i></div>
              <div class="select-wrp" v-else-if="invoice.select"><i class="iconfont select-font-active" v-tap="{methods: cancelInvoice, params:{invoice}}">&#xe69d;</i></div>
            </template>
            <IncomeCard
              type="income"
              :invoice="invoice"
              :incomeParams="{remark: invoice.remark}"
            />
          </van-swipe-cell>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="select-footer" v-if="this.cardOpened">
      <div class="wrp">
        <div class="select-wrp" v-if="selectCount === 0 || selectCount !== getCouldSelectedCount(invoiceList)"><i class="iconfont select-font" v-tap="{methods: selectAllInvoice, params:{}}">&#xe69c;</i></div>
        <div class="select-wrp" v-else-if="selectCount === getCouldSelectedCount(invoiceList)"><i class="iconfont select-font-active" v-tap="{methods: cancelAllInvoice, params:{}}">&#xe69d;</i></div>
        <div class="content">全选</div>
        <div class="content">已选择<span>{{selectCount}}张</span>发票</div>
      </div>
      <div class="btn-wrp">
        <van-button
          class="btn"
          round
          @click="openAllCard"
        >
          取消
        </van-button>
        <van-button
          class="btn"
          round
          @click="commitSelect"
        >
          关联快递单
        </van-button>
      </div>
    </div>
    <div class="pop-picker-container">
      <van-popup v-model="logisticsVisible" get-container=".pop-picker-container">
        <div class="pop-inner">
          <p class="title">关联快递单</p>
          <div v-if="showForm">
            <FormList
              :list="formList"
              :data="editData"
              :onChange="onInputChange"
              :onBlur="onBlur"
              :onFocus="onFocus"
            />
            <van-button
              loading-type="spinner"
              class="submit-btn"
              type="info"
              @click="confirmLogistics(true)"
              >确认</van-button
            >
          </div>
          <div v-else class="company-list">
            <div class="scroll-wrp">
             <ul>
               <li v-for="(item, key) in shipperCodeArr" :key="key" @click="selectShipper(item)">
                <div class="select-wrp" v-if="item.shipperName !== editData.shipperName"><i class="iconfont select-font" >&#xe69c;</i></div>
                <div class="select-wrp" v-else><i class="iconfont select-font-active" >&#xe69d;</i></div>
                <p>{{item.shipperName}}</p>
              </li>
             </ul>
            </div>
            <van-button
              loading-type="spinner"
              class="submit-btn"
              type="info"
              @click="showForm = true"
              >返回</van-button
            >
          </div>

        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { messageRequest } from '@services'
import IncomeCard from '@components/IncomeCard'
import moment from 'moment'
import { debounce, isEmpty } from '@utils/basicUtil'
import FormList from '@components/FormList'
import {
  DropdownMenu,
  DropdownItem,
  List,
  PullRefresh,
  Notify,
  SwipeCell,
  Button,
  Popup
} from 'vant'
export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    [Popup.name]: Popup,
    IncomeCard,
    FormList
  },
  props: {},
  data () {
    return {
      invoiceTypeOptions: [
        { text: '全部类型', value: '01,02,03,04,11,15,17,24,30,66,200,199,201,202,203,204,205,206,207,-1' },
        { text: '专票', value: '01' },
        { text: '普票', value: '04' },
        { text: '卷票', value: '11' },
        { text: '定额发票', value: '200' },
        { text: '火车票', value: '201' },
        { text: '飞机票', value: '202' },
        { text: '出租车票', value: '207' }
      ],
      drewDateOptions: [
        { text: '开票日期', value: undefined }
      ],
      searchParams: {
        size: 25,
        current: 1,
        name: '',
        logisticsStatus: 0, // 0 待寄送 1 待签收
        invoiceType: '01,02,03,04,11,15,17,24,30,66,200,199,201,202,203,204,205,206,207,-1'
      },
      searchOptions: {
        drewDate: undefined
      },
      invoiceList: [],
      refreshing: false,
      loading: false,
      finished: false,
      cardOpened: false,
      selectCount: 0,
      logisticsVisible: false,
      showForm: true,
      formList: [
        {
          type: 'text',
          field: 'logisticsNo',
          label: '',
          placeholder: '请输入快递单号'
        },
        {
          type: 'text',
          field: 'mobile',
          label: '',
          placeholder: '请输入寄件人电话'
        },
        {
          type: 'text',
          field: 'shipperName',
          label: '',
          placeholder: '请选择快递公司'
        }
      ],
      editData: {
        logisticsNo: '',
        mobile: '',
        shipperName: '',
        shipperCode: ''
      },
      shipperCodeArr: []
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.initDrewDateOptions()
    this.getInvoiceList()
    this.getShapperNameList()
  },
  activated () {},
  updated () {},
  methods: {
    onInputChange ({ e, field }) {
      if (field === 'logisticsNo') {
        if (e && e.length > 3) {
          this.debounce(this, e)
        }
      }
      this.editData = {
        ...this.editData,
        [field]: e
      }
    },
    onBlur ({ e, field }) {
      if (field === 'name') {
      }
    },
    onFocus ({ e, field }) {
      if (field === 'shipperName') {
        this.showForm = false
      }
    },
    initDrewDateOptions () {
      let drewDateOptions = [
        { text: '开票日期', value: undefined }
      ]
      var data = new Date()
      // var year = data.getFullYear()
      data.setMonth(data.getMonth() + 1, 1) // 获取到当前月份,设置月份
      for (var i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        var m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        let value = data.getFullYear() + '-' + (m)
        drewDateOptions.push({ text: value, value: value })
      }
      this.drewDateOptions = drewDateOptions
    },
    debounce: debounce((vm, value) => { vm.getMatchShipper(value) }, 1000),
    async getMatchShipper (shipperCode) {
      let params = {
        shipperCode: shipperCode
      }
      const data = await messageRequest.logistics.getMatchShipper(params)
      if (data.success) {
        if (data.result && data.result[0]) {
          this.onInputChange({
            e: data.result[0].shipperCode,
            field: 'shipperCode'
          })
          this.onInputChange({
            e: data.result[0].shipperName,
            field: 'shipperName'
          })
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async getShapperNameList () {
      const data = await messageRequest.logistics.getshipperNameList({})
      if (data.success) {
        this.shipperCodeArr = data.result
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async getInvoiceList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const postData = {
        ...this.searchParams
      }
      const data = await messageRequest.todo.getTicketPageByIds(postData)
      if (data.success) {
        if (data.result.records) {
          this.invoiceList = [...this.invoiceList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        Notify({ type: 'danger', message: data.message })
      }

      this.loading = false
    },
    onRefresh () {
      this.finished = false
      this.searchParams.current = 1
      this.cardOpened = false
      this.selectCount = 0
      this.invoiceList = []
      this.getInvoiceList()
    },
    onLoad () {
      this.searchParams.current++
      this.getInvoiceList()
    },
    changeType (value) {
      this.searchParams.changeType = value
      this.onRefresh()
    },
    changeDrewDate (value) {
      if (value) {
        this.searchParams.startTime = moment(value).startOf('month').format('YYYY-MM-DD HH:mm:ss')
        this.searchParams.endTime = moment(value).endOf('month').format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchParams.startTime = ''
        this.searchParams.endTime = ''
      }
      this.onRefresh()
    },
    selectInvoice (data) {
      let list = [...this.invoiceList]
      let selectCount = 0
      list.forEach(v => {
        if (v.id === data.params.invoice.id) {
          v.select = true
        }
        if (v.select) {
          selectCount += 1
        }
      })
      this.invoiceList = list
      this.selectCount = selectCount
    },
    cancelInvoice (data) {
      let list = [...this.invoiceList]
      let selectCount = 0
      list.forEach(v => {
        if (v.id === data.params.invoice.id) {
          v.select = false
        }
        if (v.select) {
          selectCount += 1
        }
      })
      this.invoiceList = list
      this.selectCount = selectCount
    },
    selectAllInvoice (data) {
      this.invoiceList.forEach(v => {
        v.select = true
      })
      this.selectCount = this.getCouldSelectedCount(this.invoiceList)
    },
    getCouldSelectedCount (list) {
      return list.length
    },
    cancelAllInvoice (data) {
      this.invoiceList.forEach(v => {
        v.select = false
      })
      this.selectCount = 0
    },
    openAllCard () {
      if (this.cardOpened) {
        this.cardOpened = false
        Object.keys(this.$refs).forEach(key => {
          if (key.includes('swipecell')) {
            this.$refs[key][0] && this.$refs[key][0].close('left')
          }
        })
      } else {
        this.cardOpened = true
        Object.keys(this.$refs).forEach(key => {
          if (key.includes('swipecell')) {
            this.$refs[key][0] && this.$refs[key][0].open('left')
          }
        })
      }
    },
    commitSelect () {
      if (this.selectCount === 0) {
        Notify({ type: 'danger', message: '请选择数据' })
        return
      }
      this.logisticsVisible = true
    },
    async confirmLogistics () {
      if (!this.testField('logisticsNo') || !this.testField('mobile') || !this.testField('shipperName')) {
        return
      }
      let ids = []
      this.invoiceList.forEach(v => {
        if (v.select) {
          ids.push(v.id)
        }
      })
      let params = {
        logisticsNo: this.editData.logisticsNo,
        mobile: this.editData.mobile,
        shipperCode: this.editData.shipperCode,
        shipperName: this.editData.shipperName,
        ticketIdList: ids
      }
      const data = await messageRequest.todo.relateLogistics(params)
      if (data.success) {
        this.logisticsVisible = false
        this.onRefresh()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    testField (type) {
      const fieldObj = {
        logisticsNo: '请输入快递单号',
        mobile: '请输入寄件人电话',
        shipperName: '请选择快递公司'
      }
      if (isEmpty(this.editData[type])) {
        Notify({ type: 'danger', message: `${fieldObj[type]}` })
        return false
      }
      return true
    },
    selectShipper (item) {
      this.onInputChange({
        e: item.shipperCode,
        field: 'shipperCode'
      })
      this.onInputChange({
        e: item.shipperName,
        field: 'shipperName'
      })
      this.showForm = true
    },
    beforeClose ({ position, instance }) {
      switch (position) {
        case 'left':
          break
      }
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
